const items = ["LOW IMPACT", "FULL BODY", "ZERO GRAVITY", "REHAB READY", "RACE DAY", "ALL AGES"];

export const Marquee = () => {
  return (
    <section data-testid="marquee" className="border-y border-textMuted/15 py-8">
      <div className="relative flex overflow-hidden">
        <div className="animate-marquee flex shrink-0 items-center whitespace-nowrap">
          {[...items, ...items].map((t, i) => (
            <span key={i} className="mx-8 flex items-center gap-8">
              <span className="text-stroke font-display text-6xl font-900 tracking-tight md:text-8xl">{t}</span>
              <span className="h-3 w-3 rounded-full bg-aqua" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};
